import React, { useEffect, useState } from "react";
import FirstMonthAssessmentForm from "./FirstMonthAssessmentForm";
import { Form, message, Radio } from "antd";
import {
  getFirstMonthAssessmentQuestionsByEmployeeId,
  updateFirstMonthAssessmentResponses,
} from "../../api/FirstMonthAssessmentApi";
import { addNotification } from "../../api/NotificationApi";
import { getEmployeeByAssessmentToken } from "../../api/EmployeeApi";
import { useSearchParams } from "react-router-dom";
import { GetUserByDepartmentId } from "../../api/UserApi";
import { Departement, dateFormat } from "../common/GeneralConfigurations";
import moment from "moment";

export const ManageFirstMonthAssessmentPage = () => {
  const [searchParams] = useSearchParams();
  const [employee, setEmployee] = useState({
    employeeId: null,
    employeeName: null,
    managerName: null,
    admissionDate: null,
    isEmailEnglishLanguage: null,
  });
  const [value, setValue] = useState([]);
  const [valueString, setValueString] = useState([]);

  const [firstMonthAssessmentQuestions, setFirstMonthAssessmentQuestions] =
    useState([]);
  const [invalidToken, setInvalidToken] = useState(false);
  const [messageError1, setMessageError1] = useState(false);
  const [messageError2, setMessageError2] = useState(false);
  const [form] = Form.useForm();

  const [assignedToList, setAssignedToList] = useState([]);

  const fetchEmployee = async () => {
    if (!searchParams.get("token")) {
      setInvalidToken(true);
      return;
    }

    const res = await getEmployeeByAssessmentToken(searchParams.get("token"));
    if (res.status == 400 || res.status == 404) {
      setInvalidToken(true);
      return;
    }
    const { id, name, managerName, admissionDate, isEmailEnglishLanguage } =
      res.data;
    const splitEmployeeName = name.split(" ");
    const splitManagerName = managerName.split(" ");

    setEmployee({
      employeeId: id,
      employeeName:
        splitEmployeeName[0] +
        " " +
        splitEmployeeName[splitEmployeeName.length - 1],
      managerName:
        splitManagerName[0] +
        " " +
        splitManagerName[splitManagerName.length - 1],
      admissionDate: moment(admissionDate).format(dateFormat),//.split("T")[0],
      isEmailEnglishLanguage: isEmailEnglishLanguage,
    });
  };

  const onChange = (e, group) => {
    const tmp = [...value];
    const tmpString = [...valueString];
    tmp[group] = e.target.value;
    tmpString[group] = e.target.value.toString();
    setValue(tmp);
    setValueString(tmpString);
  };

  const fetchFirstMonthAssessmentQuestions = async (id) => {
    const res = await getFirstMonthAssessmentQuestionsByEmployeeId(id);
    setFirstMonthAssessmentQuestions(res.data);
  };

  useEffect(() => {
    fetchEmployee();
  }, []);

  useEffect(async () => {
    let HRList = [];
    await GetUserByDepartmentId(Departement.HumanResources).then((res) => {
      if (res.status === 200) {
        HRList = res.data.result;
      }
    });
    setAssignedToList(HRList);
  }, []);

  useEffect(() => {
    if (employee.employeeId != null) {
      fetchFirstMonthAssessmentQuestions(employee.employeeId);
    }
    form.resetFields();
  }, [employee]);

  const handleFinish = async () => {
    let valueStringFinishQuestion1 = valueString.slice(3, 8);
    let valueStringFinishQuestion2 = valueString.slice(8, 12);
    if (
      valueStringFinishQuestion1.includes(undefined) ||
      valueStringFinishQuestion1.length < 5
    ) {
      setMessageError1(true);
      window.scrollTo({ top: 280, left: 0, behavior: "smooth" });
      return;
    } else {
      setMessageError1(false);
    }
    if (
      valueStringFinishQuestion2.includes(undefined) ||
      valueStringFinishQuestion2.length < 4
    ) {
      setMessageError2(true);
      window.scrollTo({ top: 700, left: 0, behavior: "smooth" });
      return;
    } else {
      setMessageError2(false);
    }

    assignedToList.forEach(async (element, index) => {
      const res2 = await addNotification({
        description: "Employee "
          .concat(employee.employeeName)
          .concat(" has filled out his first month assessment."),
        userId: assignedToList[index].id,
        notificationTypeId: 6,
        link: "/consultant/".concat(employee.employeeId),
        isRead: false,
      });
    });

    valueString.forEach(async (element, index) => {
      const res = await updateFirstMonthAssessmentResponses({
        id: firstMonthAssessmentQuestions[index].firstMonthAssessmentQuestionId,
        employeeId: employee.employeeId,
        response: element,
      });
      if (res.status == 200 && index == 11) {
        setInvalidToken(true);
        message.success("First Month Assessment answered with success");
        window.scrollTo({ top: 300, left: 0, behavior: "smooth" });
        return;
      }
      if (res.status == 404) {
        setInvalidToken(true);
        message.error("Fail to send First Month Assessment");
        return;
      }
    });
  };

  return (
    <>
      <FirstMonthAssessmentForm
        employee={employee}
        invalidToken={invalidToken}
        messageError1={messageError1}
        messageError2={messageError2}
        firstMonthAssessmentQuestions={firstMonthAssessmentQuestions}
        form={form}
        handleFinish={handleFinish}
        values={value}
        onChange={onChange}
      />
    </>
  );
};
